import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardText, Button } from "reactstrap";
import { Link } from "react-router-dom";
import JsPDF from "jspdf";             // ✅ Capitalized import
import autoTable from "jspdf-autotable";
import ComponentCard from "../../components/ComponentCard";

const VendorOldProject = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedLocation, setSelectedLocation] = useState("");

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 24;

    // Fetch all old projects
    const fetchData = async () => {
        try {
            const response = await fetch("https://amaapi.outdoorooh.com/api/old-project");
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const result = await response.json();
            setData(result.data || []);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Get unique locations
    const uniqueLocations = [...new Set(data.map((item) => item.state).filter(Boolean))];

    // Filtering logic
    const filteredData = data.filter((item) => {
        const term = searchTerm.toLowerCase();
        const matchesSearch =
            item.site_name?.toLowerCase().includes(term) ||
            item.code?.toLowerCase().includes(term) ||
            item.state?.toLowerCase().includes(term) ||
            item.zone?.toLowerCase().includes(term);

        const matchesLocation = selectedLocation ? item.state === selectedLocation : true;
        return matchesSearch && matchesLocation;
    });

    // Pagination slice
    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentData = filteredData.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageChange = (page) => setCurrentPage(page);

    const generateStatePDF = (projects, stateName) => {
        const doc = new JsPDF();

        projects.forEach((project, index) => {
            if (index > 0) doc.addPage(); // Add new page for each project

            // Title row
            doc.setFontSize(12);
            doc.text(
                `Site Name : ${project.site_name || ""}     Code : ${project.code || ""}`,
                14,
                15
            );

            // First table (basic details)
            autoTable(doc, {
                startY: 25,
                body: [
                    [
                        { content: "Zone", styles: { fontStyle: "bold" } },
                        project.zone || "",
                        { content: "State", styles: { fontStyle: "bold" } },
                        project.state || "",
                        { content: "Area", styles: { fontStyle: "bold" } },
                        project.area || "",
                    ],
                   
                    [
                        { content: "Height", styles: { fontStyle: "bold" } },
                        project.length || "",
                        { content: "Width", styles: { fontStyle: "bold" } },
                        project.width || "",
                        { content: "Unit", styles: { fontStyle: "bold" } },
                        project.unit || "",
                    ],
                    [
                        { content: "Total Sqft.", styles: { fontStyle: "bold" } },
                        project.total || "",
                        { content: "Lat", styles: { fontStyle: "bold" } },
                        project.lat || "",
                        { content: "Long", styles: { fontStyle: "bold" } },
                        project.long || "",
                    ],
                    [
                        { content: "Illumination", styles: { fontStyle: "bold" } },
                        project.illumination || "",
                        { content: "Type", styles: { fontStyle: "bold" } },
                        project.type || "",
                        { content: "Vendor Status", styles: { fontStyle: "bold" } },
                        project.vendor_status || "",
                    ],
                    [
                        { content: "Airtel Team", styles: { fontStyle: "bold" } },
                        project.airtel_team || "",
                        { content: "Recce Person Name", styles: { fontStyle: "bold" } },
                        project.racce_person_name || "",
                        { content: "Recce Person Image :", styles: { fontStyle: "bold" } },
                       project.racce_person_image || "",
                    ],
                    [
                        { content: "Image Updated Date :", styles: { fontStyle: "bold" } },
                        project.updated_at || "",
                       { content: "Vendor Name", styles: { fontStyle: "bold" } },
                        project.vendor_name || "", "", "", ""
                    ],
                ],
                theme: "grid",
                styles: { halign: "left", valign: "middle" },
                columnStyles: {
                    0: { cellWidth: 30 },
                    1: { cellWidth: 30 },
                    2: { cellWidth: 30 },
                    3: { cellWidth: 30 },
                    4: { cellWidth: 30 },
                    5: { cellWidth: 30 },
                },
            });

            // Insert Recce Person Image (if available)
            if (project.recce_person_image) {
                const imgUrl = `https://amaapi.outdoorooh.com/${project.recce_person_image}`;
                doc.addImage(imgUrl, "JPEG", 160, 85, 20, 20);
            }

            const finalY = doc.lastAutoTable.finalY + 10;
            const siteImages = [
                // project.image,
                // project.image1,
                // project.image2,
                // project.image3,
                // project.image4,
            ].filter(Boolean);

            siteImages.forEach((img, idx) => {
                const imgUrl = `https://amaapi.outdoorooh.com/${img}`;
                doc.addImage(imgUrl, "JPEG", 15, finalY + idx * 60, 180, 50);
            });
        });

        doc.save(`${stateName || "projects"}.pdf`);
    };



    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <>
            <div className="d-flex justify-content-between mb-3">
                {/* Search Input */}
                <input
                    type="text"
                    className="form-control p-2"
                    placeholder="Search here"
                    style={{ maxWidth: "300px" }}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />

                {/* Location Filter */}
                <select
                    className="form-control p-2"
                    style={{ maxWidth: "200px" }}
                    value={selectedLocation}
                    onChange={(e) => setSelectedLocation(e.target.value)}
                >
                    <option value="">All Locations</option>
                    {uniqueLocations.map((loc) => (
                        <option key={loc} value={loc}>
                            {loc}
                        </option>
                    ))}
                </select>

                {/* Download PDF */}
                <Button
                    color="success"
                    disabled={!selectedLocation}
                    onClick={() => {
                        const stateProjects = filteredData.filter(
                            (p) => p.state === selectedLocation
                        );
                        if (stateProjects.length > 0) {
                            generateStatePDF(stateProjects, selectedLocation);
                        } else {
                            alert("No projects found for this state");
                        }
                    }}
                >
                    Download {selectedLocation || "State"} PDF
                </Button>


            </div>

            <ComponentCard title="Scam campaign">
                <Row>
                    {currentData.length > 0 ? (
                        currentData.map((item) => (
                            <Col md="6" lg="4" key={item.id}>
                                <Card body>
                                    <div
                                        id={`carousel-${item.id}`}
                                        className="carousel slide"
                                        data-bs-touch="false"
                                    >
                                        <div className="carousel-inner">
                                            {[item.image, item.image1, item.image2, item.image3, item.image4]
                                                .filter((img) => img)
                                                .map((img, index) => (
                                                    <div
                                                        key={img}
                                                        className={`carousel-item ${index === 0 ? "active" : ""}`}
                                                    >
                                                        <img
                                                            src={`https://amaapi.outdoorooh.com/${img}`}
                                                            loading="lazy"
                                                            className="d-block w-100"
                                                            style={{ height: "200px" }}
                                                            alt={item.site_name}
                                                        />
                                                    </div>
                                                ))}
                                        </div>

                                        {/* Controls */}
                                        {[item.image, item.image1, item.image2, item.image3, item.image4].filter(
                                            (img) => img
                                        ).length > 1 && (
                                                <>
                                                    <button
                                                        type="button"
                                                        className="carousel-control-prev"
                                                        data-bs-target={`#carousel-${item.id}`}
                                                        data-bs-slide="prev"
                                                    >
                                                        <span
                                                            className="carousel-control-prev-icon"
                                                            aria-hidden="true"
                                                        ></span>
                                                        <span className="visually-hidden">Previous</span>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="carousel-control-next"
                                                        data-bs-target={`#carousel-${item.id}`}
                                                        data-bs-slide="next"
                                                    >
                                                        <span
                                                            className="carousel-control-next-icon"
                                                            aria-hidden="true"
                                                        ></span>
                                                        <span className="visually-hidden">Next</span>
                                                    </button>
                                                </>
                                            )}
                                    </div>

                                    <Link
                                        to={`/vendor-old-project-detail/${item.id}`}
                                        style={{
                                            color: "#333",
                                            textDecoration: "none",
                                            marginTop: "10px",
                                            display: "block",
                                        }}
                                    >
                                        <CardText>{item.code}</CardText>
                                        <CardText>{item.site_name}</CardText>
                                        <CardText>{item.state}</CardText>
                                    </Link>
                                </Card>
                            </Col>
                        ))
                    ) : (
                        <p>No projects found.</p>
                    )}
                </Row>

                {/* Pagination */}
                <div className="d-flex justify-content-center mt-3">
                    <nav>
                        <ul className="pagination">
                            {Array.from({ length: totalPages }, (_, i) => (
                                <li
                                    key={i}
                                    className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                >
                                    <button
                                        type="button"
                                        className="page-link"
                                        onClick={() => handlePageChange(i + 1)}
                                    >
                                        {i + 1}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
            </ComponentCard>
        </>
    );
};

export default VendorOldProject;
